import React, {Component} from 'react';
import './DialogTextInputFilter.css';
import {Input, Button} from 'antd';

class DialogTextInputFilter extends Component {

    render() {
        return <div className="custom-filter-dropdown">
            <Input
                placeholder={this.props.placeholder}
                value={this.props.selectedKeys}
                onChange={this.props.onChange}
                onPressEnter={this.props.onSearch}
            />
            <Button type="primary" onClick={this.props.onSearch}>Filtrar</Button>
            <Button onClick={this.props.onReset}>Limpiar</Button>
        </div>
    }
}

export default DialogTextInputFilter;


// WEBPACK FOOTER //
// ./src/app/components/DialogTextInputFilter.js